<template>
    <div class="blog-post-area">
        <div class="container-fluid">
            <div class="blog-details-content card-box-style">
                <h2>Java Projects: Ideas To Teach You latest Java Programming In 2022</h2>

                <ul class="tags">
                    <li>
                        <router-link to="/blog">AWS</router-link>
                    </li>
                    <li>
                        <router-link to="/blog">Programming</router-link>
                    </li>
                    <li>
                        <router-link to="/blog">React</router-link>
                    </li>
                    <li>
                        <router-link to="/blog">Trend2021</router-link>
                    </li>
                    <li>
                        <router-link to="/blog">Developer</router-link>
                    </li>
                    <li>
                        <router-link to="/blog">javascript</router-link>
                    </li>
                    <li>
                        <router-link to="/blog">WordPress</router-link>
                    </li>
                </ul>

                <ul class="poster-info">
                    <li>
                        <img src="../../assets/images/blog/admin-1.jpg" alt="admin-1">
                        <span>Written By</span>
                        <router-link to="/profile">Binter Carol</router-link>
                    </li>
                    <li>12 Dec, 2021</li>
                    <li>6 min read</li>
                </ul>

                <div class="blog-post-img">
                    <img src="../../assets/images/blog/blog-3.jpg" alt="Ideas">
                </div>

                <p>Lorem ipsum dolor sit amet, consectetur adipiscing elit. Scelerisque interdum nunc donec sed. Molestie pretium por dictum id eu, erat massa. Ut vulputate fermentum, lorem <router-link to="/blog-details">New Trend In 2022</router-link> Iiaculis lobortis consectetur. Vitae vulputate massa in lobortis. Interdum purus sit urna, morbi ornare.</p>

                <p>Lorem ipsum dolor sit amet, consectetur adipiscing elit. Scelerisque interdum nunc donec sed. Molestie pretium por dictum id eu, erat massa. Ut vulputate fermentum, lorem Iiaculis lobortis consectetur.</p>

                <div class="gap-mb-50"></div>

                <blockquote>
                    <p><i class="ri-double-quotes-l"></i> Lorem ipsum dolor sit amet, consectetur adipiscing elit. Scelerisque interdum nunc donec sed. Molestie pretium por dictum id eu, erat massa. Ut vulputate fermentum, int lorem Iiaculis lobortis consectetur.</p>
                </blockquote>

                <div class="gap-mb-50"></div>

                <p>Lorem ipsum dolor sit amet, consectetur adipiscing elit. Scelerisque interdum nunc donec sed. Molestie pretium por dictum id eu, erat massa. Ut vulputate fermentum, lorem New Trend AWS Blog Iiaculis lobortis consectetur. Vitae vulpu tate massa in lobortis. Interdum purus sit urna, morbi ornare.</p>

                <p>Lorem ipsum dolor sit amet, consectetur adipiscing elit. Scelerisque interdum nunc donec sed. Molestie pretium por dictum id eu, erat massa. Ut vulputate fermentum, lorem Iiaculis lobortis consectetur.</p>

                <div class="gap-mb-50"></div>

                <h3>Learn To Code To Become A Web Developer</h3>
                <p>Lorem ipsum dolor sit amet, consectetur adipiscing elit. Scelerisque interdum nunc donec sed. Molestie pretium por dictum id eu, erat massa. Ut vulputate fermentum, lorem New Trend AWS Blog Iiaculis lobortis consectetur. Vitae vulpu tate massa in lobortis. Interdum purus sit urna, morbi ornare.</p>
                <p>Lorem ipsum dolor sit amet, consectetur adipiscing elit. Scelerisque interdum nunc donec sed. Molestie pretium por dictum id eu, erat massa. Ut vulputate fermentum, lorem Iiaculis lobortis consectetur.</p>

                <div class="gap-mb-50"></div>

                <div class="blog-video">
                    <img src="../../assets/images/blog/blog-2.jpg" alt="Image">

                    <div class="video-btns">
                        <a href="https://www.youtube.com/watch?v=_aB9Tg6SRA0" class="video-btn popup-youtube">
                            <i class="ri-play-fill"></i>
                        </a>
                    </div>
                </div>

                <div class="gap-mb-50"></div>

                <p>Lorem ipsum dolor sit amet, consectetur adipiscing elit. Scelerisque interdum nunc donec sed. Molestie pretium por dictum id eu, erat massa. Ut vulputate fermentum, lorem New Trend AWS Blog Iiaculis lobortis consectetur. Vitae vulpu tate massa in lobortis. Interdum purus sit urna, morbi ornare.</p>

                <p>Lorem ipsum dolor sit amet, consectetur adipiscing elit. Scelerisque interdum nunc donec sed. Molestie pretium por dictum id eu, erat massa. Ut vulputate fermentum, lorem Iiaculis lobortis consectetur.</p>

                <div class="gap-mb-50"></div>

                <ul class="social-link">
                    <li>
                        <span>Share The Post:</span>
                    </li>
                    <li>
                        <a href="https://www.facebook.com/" target="_blank">
                            <i class="ri-facebook-fill"></i>
                        </a>
                    </li>
                    <li>
                        <a href="https://www.instagram.com/" target="_blank">
                            <i class="ri-instagram-line"></i>
                        </a>
                    </li>
                    <li>
                        <a href="https://www.twitter.com/" target="_blank">
                            <i class="ri-twitter-fill"></i>
                        </a>
                    </li>
                    <li>
                        <a href="https://www.linkedin.com/" target="_blank">
                            <i class="ri-linkedin-fill"></i>
                        </a>
                    </li>
                </ul>

                <div class="gap-mb-50"></div>

                <div class="post-author d-flex justify-content-between align-items-center">
                    <div class="post-avatar d-flex align-items-center">
                        <img src="../../assets/images/blog/admin-6.jpg" alt="admin-6">
                        <div class="author-info">
                            <h4>Binter Carol</h4>
                            <span>Web Developer</span>
                        </div>
                    </div>

                    <router-link to="/instructor-details" class="default-btn">
                        View Binter’s Profile
                    </router-link>
                </div>

                <p>Lorem ipsum dolor sit amet, consectetur adipiscing elit. Scelerisque interdum nunc donec sed. Molestie pretium por dictum id eu, erat massa. Ut vulputate fermentum, lorem New Trend AWS Blog Iiaculis lobortis consectetur. Vitae vulpu tate massa in lobortis. Interdum purus sit urna, morbi ornare... <router-link to="/blog-details">Read More</router-link></p>

                <div class="gap-mb-50"></div>

                <div class="related-articles">
                    <div class="related-title d-flex justify-content-between">
                        <h3>Related Articles</h3>
                        <router-link to="/blog-details" class="read-more">View All <i class="ri-arrow-right-line"></i></router-link>
                    </div>
                    <div class="row justify-content-between">
                        <div class="col-lg-6 col-md-6">
                            <div class="single-blog">
                                <div class="blog-img">
                                    <router-link to="/blog-details">
                                        <img src="../../assets/images/blog/blog-1.jpg" alt="Image">
                                    </router-link>
                                    <span class="date">12 Dec</span>
                                </div>
    
                                <div class="blog-content">
                                    <h3>
                                        <router-link to="/blog-details">The Swag (And Humans) Of AWS Re: Invent 2021 Reviewed</router-link>
                                    </h3>
    
                                    <ul class="d-flex justify-content-between">
                                        <li>
                                            <router-link to="/blog-details"><img src="../../assets/images/blog/admin-1.jpg" alt="admin-1"></router-link>
                                            <span>By</span>
                                            <router-link to="/blog-details">Binter Carol</router-link>
                                        </li>
                                        <li>
                                            <router-link to="/blog-details" class="read-more">
                                                Read Blog
                                                <i class="ri-arrow-right-line"></i>
                                            </router-link>
                                        </li>
                                    </ul>
                                </div>
                            </div>
                        </div>
    
                        <div class="col-lg-6 col-md-6">
                            <div class="single-blog">
                                <div class="blog-img">
                                    <router-link to="/blog-details">
                                        <img src="../../assets/images/blog/blog-2.jpg" alt="Image">
                                    </router-link>
                                    <span class="date">12 Dec</span>
                                </div>
    
                                <div class="blog-content">
                                    <h3>
                                        <router-link to="/blog-details">University Admissions Could Face Emergency Controls</router-link>
                                    </h3>
    
                                    <ul class="d-flex justify-content-between">
                                        <li>
                                            <router-link to="/blog-details"><img src="../../assets/images/blog/admin-2.jpg" alt="admin-2"></router-link>
                                            <span>By</span>
                                            <router-link to="/blog-details">Staven Dew</router-link>
                                        </li>
                                        <li>
                                            <router-link to="/blog-details" class="read-more">
                                                Read Blog
                                                <i class="ri-arrow-right-line"></i>
                                            </router-link>
                                        </li>
                                    </ul>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                <div class="comments">
                    <h3>Comments</h3>

                    <ul>
                        <li class="d-flex justify-content-between align-items-start">
                            <img src="../../assets/images/blog/admin-7.jpg" alt="admin-7">
                            <div class="comment-onfo">
                                <div class="d-flex justify-content-between">
                                    <h4>Binter Carol <span>12 Dec 2021</span></h4>
                                    <router-link to="/blog-details" class="read-more">Reply <i class="ri-arrow-right-line"></i></router-link>
                                </div>
                                <p>Lorem ipsum dolor sit amet, consectetur adipiscing elit. Scelerisque interdum nunc donec sed. Molestie pretium por dictum id eu, erat massa. Ut vulputate fermentum, lorem New Trend AWS Blog Iiaculis lobortis consectetur. Vitae vulpu tate massa in lobortis. Interdum purus sit urna, morbi ornare.</p>
                            </div>
                        </li>
                        <li class="d-flex justify-content-between align-items-start reply">
                            <img src="../../assets/images/blog/admin-8.jpg" alt="admin-8">
                            <div class="comment-onfo">
                                <div class="d-flex justify-content-between">
                                    <h4>Angela Carter <span>12 Dec 2021</span></h4>
                                    <router-link to="/blog-details" class="read-more">Reply <i class="ri-arrow-right-line"></i></router-link>
                                </div>
                                <p>Lorem ipsum dolor sit amet, consectetur adipiscing elit. Scelerisque interdum nunc donec sed. Molestie pretium por dictum id eu, erat massa. Ut vulputate fermentum, lorem New Trend AWS Blog Iiaculis lobortis consectetur. Vitae vulpu tate massa in lobortis. Interdum purus sit urna, morbi ornare.</p>
                            </div>
                        </li>
                        <li class="d-flex justify-content-between align-items-start">
                            <img src="../../assets/images/blog/admin-9.jpg" alt="admin-9">
                            <div class="comment-onfo">
                                <div class="d-flex justify-content-between">
                                    <h4>Victor James <span>12 Dec 2021</span></h4>
                                    <router-link to="/blog-details" class="read-more">Reply <i class="ri-arrow-right-line"></i></router-link>
                                </div>
                                <p>Lorem ipsum dolor sit amet, consectetur adipiscing elit. Scelerisque interdum nunc donec sed. Molestie pretium por dictum id eu, erat massa. Ut vulputate fermentum, lorem New Trend AWS Blog Iiaculis lobortis consectetur. Vitae vulpu tate massa in lobortis. Interdum purus sit urna, morbi ornare.</p>
                            </div>
                        </li>
                    </ul>
                </div>

                <div class="gap-mb-50"></div>

                <div class="leave-comment">
                    <h3>Leave A Comment</h3>
                    <p>Your email address will not be published. Required fields are marked *</p>
                    <form @submit.prevent>
                        <div class="row">
                            <div class="col-lg-6">
                                <div class="form-group">
                                    <input type="text" class="form-control" placeholder="Name">
                                </div>
                            </div>
                            <div class="col-lg-6">
                                <div class="form-group">
                                    <input type="email" class="form-control" placeholder="Email">
                                </div>
                            </div>
                            <div class="col-lg-12">
                                <div class="form-group">
                                    <textarea class="form-control" cols="30" rows="10" placeholder="Your Message"></textarea>
                                </div>
                            </div>
                            <div class="col-lg-12">
                                <div class="form-group">
                                    <div class="form-check">
                                        <input class="form-check-input" type="checkbox" value="" id="flexCheckDefault">
                                        <label class="form-check-label" for="flexCheckDefault">
                                            Save my name, email, and website in this browser for the next time I comment.
                                        </label>
                                    </div>
                                </div>
                            </div>

                            <div class="col-lg-12">
                                <button type="submit" class="default-btn">
                                    Post A Comment
                                </button>
                            </div>
                        </div>
                    </form>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: 'BlogDetails'
}
</script>

<style lang="scss">
.blog-details-content {
	max-width: 900px;
	margin: auto;
	margin-bottom: 30px;
	.gap-mb-50 {
		margin-bottom: 50px;
	}
	h2 {
		font-size: 24px;
		margin-bottom: 25px;
	}
	.tags {
		padding-left: 0;
		margin-bottom: 20px;
		list-style: none;
		li {
			display: inline-block;
			margin-right: 10px;
			&:last-child {
				margin-right: 0;
			}
			a {
				background-color: #F2F0EF;
				display: inline-block;
				padding: 10px 12px;
				border-radius: var(--border-radius);
			}
		}
	}
	.poster-info {
		padding-left: 0;
		margin-bottom: 30px;
		list-style-type: none;
		li {
			display: inline-block;
			margin-right: 40px;
			position: relative;
			&::before {
				content: "";
				position: absolute;
				top: 9px;
				right: -24px;
				width: 5px;
				height: 5px;
				background-color: var(--main-color);
				border-radius: 50px;
			}
			&:last-child {
				margin-right: 0;
				&::before {
					display: none;
				}
			}
			a {
				color: var(--heading-color);
			}
			img {
				position: relative;
				top: -2px;
				margin-right: 5px;
				border-radius: 50px;
			}
		}
	}
	.blog-post-img {
		margin-bottom: 30px;
	}
	p {
		a {
			color: var(--main-color);
		}
	}
	blockquote {
		background-color: #F6FAFB;
		padding: 30px;
		padding-left: 70px;
		border-left: 2px solid var(--main-color);
		margin-top: 30px;
		margin-bottom: 30px;
		p {
			font-size: 20px;
			color: var(--heading-color);
			position: relative;
			i {
				position: absolute;
				top: -10px;
				left: -25px;
				color: var(--main-color);
			}
		}
	}
	h3 {
		font-size: 20px;
		margin-bottom: 10px;
	}
	.blog-video {
		position: relative;
		.video-btns {
			position: absolute;
			top: 50%;
			left: 0;
			right: 0;
			text-align: center;
			transform: translateY(-50%);
		}
	}
	.social-link {
		padding-left: 0;
		margin-bottom: 0;
		list-style-type: none;
		text-align: center;
		border-top: 1px solid #eaeaea;
		border-bottom: 1px solid #eaeaea;
		padding-top: 20px;
		padding-bottom: 20px;
		li {
			display: inline-block;
			margin-right: 10px;
			&:last-child {
				margin-right: 0;
			}
			span {
				font-size: 20px;
				color: var(--heading-color);
				font-weight: 600;
				position: relative;
				top: -2px;
			}
			a {
				display: inline-block;
				width: 30px;
				height: 30px;
				line-height: 30px;
				text-align: center;
				background: linear-gradient(133.65deg, #6CC17E 2.24%, #098B99 100%);
				color: var(--white-color);
				border-radius: 50px;
				transition: var(--transition);
				&:hover {
					transform: translateY(-2px);
				}
			}
		}
	}
	.post-author {
		margin-bottom: 20px;
		.post-avatar {
			img {
				border-radius: 50px;
				position: relative;
				top: -5px;
				margin-right: 10px;
			}
			.author-info {
				h4 {
					font-size: 18px;
				}
				span {
					font-size: 14px;
				}
			}
		}
	}
	.related-title {
		margin-bottom: 20px;
		h3 {
			font-size: 25px;
			margin-bottom: 0;
		}
	}
	.single-blog {
		.blog-content {
			h3 {
				font-size: 18px;
			}
		}
	}
	.comments {
		border-top: 1px solid #eaeaea;
		border-bottom: 1px solid #eaeaea;
		margin-top: 20px;
		padding-top: 50px;
		padding-bottom: 50px;
		h3 {
			margin-bottom: 20px;
		}
		ul {
			padding-left: 0;
			margin-bottom: 0;
			list-style-type: none;
			li {
				margin-bottom: 30px;
				&:last-child {
					margin-bottom: 0;
				}
				img {
					border-radius: 50%;
					margin-right: 20px;
				}
				.comment-onfo {
					h4 {
						font-size: 16px;
						margin-bottom: 0;
						span {
							font-weight: 400;
							color: var(--body-color);
							font-size: 14px;
							margin-left: 20px;
						}
					}
					.read-more {
						margin-bottom: 5px;
					}
				}
				&.reply {
					margin-left: 100px;
				}
			}
		}
	}
	.leave-comment {
		p {
			margin-bottom: 25px;
		}
		.form-group {
			margin-bottom: 30px;
		}
		.form-check-input {
			border-color: var(--main-color);
			&:checked {
				background-color: var(--main-color);
				border-color: var(--main-color);
			}
			&:focus {
				box-shadow: none;
			}
		}
		.default-btn {
			width: auto;
		}
	}
}

/* Max width 767px */
@media only screen and (max-width: 767px) {
    .blog-details-content {
        h2 {
            font-size: 20px;
        }
        .tags {
            li {
                margin-bottom: 10px;
                &:last-child {
                    margin-bottom: 0;
                }
                a {
                    padding: 5px;
                }
            }
        }
        blockquote {
            padding: 20px;
            padding-left: 20px;
            p {
                font-size: 15px;
            }
        }
        .social-link {
            li {
                margin-right: 5px;
            }
        }
        h3 {
            font-size: 16px;
        }
        .post-author {
            display: block !important;
        }
        .comments {
            ul {
                li {
                    &.reply {
                        margin-left: 0;
                    }
                }
            }
        }
    }
}

/* Min width 768px to Max width 991px */
@media only screen and (min-width: 768px) and (max-width: 991px) {
     .blog-details-content {
        h2 {
            font-size: 20px;
        }
        .tags {
            li {
                margin-bottom: 10px;
                &:last-child {
                    margin-bottom: 0;
                }
                a {
                    padding: 5px;
                }
            }
        }
        blockquote {
            padding: 20px;
            padding-left: 20px;
            p {
                font-size: 15px;
            }
        }
        .social-link {
            li {
                margin-right: 5px;
            }
        }
        h3 {
            font-size: 16px;
        }
        .post-author {
            display: block !important;
        }
        .comments {
            ul {
                li {
                    &.reply {
                        margin-left: 0;
                    }
                }
            }
        }
    }
}
</style>